import { SvgIcon, SxProps, Theme } from "@mui/material";
import { ReactElement } from "react";

export default function DownArrowSvg({
    sx,
}: {
    sx?: SxProps<Theme>;
}): ReactElement {
    return (
        <SvgIcon
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ width: "16px", height: "16px", ...sx }}
        >
            <mask
                id="mask0_4269_8572"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <rect width="16" height="16" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_4269_8572)">
                <path
                    d="M4.42998 5.3335L7.99998 8.89572L11.57 5.3335L12.6666 6.43016L7.99998 11.0968L3.33331 6.43016L4.42998 5.3335Z"
                    fill="currentColor"
                />
            </g>
        </SvgIcon>
    );
}
